import { Link } from '@fluentui/react';
import { DefaultCard } from '../../../../../DefaultCard';
import { useTranslation, Trans } from 'react-i18next';
import { ICveNumber } from '../../../../../../api/apiTypes';
import { VulnSecurityUpdatesListUpdatesTab } from './VulnSecurityUpdatesListUpdatesTab';

export type SecurityUpdateListViewKey = 'cvss' | 'updates' | 'deployments';

/**
 * Component that renders the "Security Updates" list
 */
export const SecurityUpdateListCard = ({ cveNumber }: ICveNumber) => {
  const [t] = useTranslation('vulnerability');

  return (
    <DefaultCard
      header={t('securityUpdates.Security Updates')}
      id='securityUpdates'
    >
      <p>
        <Trans
          t={t}
          i18nKey='vulnerability:securityUpdates.subtitle'
          components={[
            <Link
              key='1'
              href='https://support.microsoft.com/lifecycle'
              target='_blank'
              rel='noopener noreferrer'
            />,
          ]}
        />
      </p>
      <VulnSecurityUpdatesListUpdatesTab cveNumber={cveNumber} />
    </DefaultCard>
  );
};
